$ = jQuery.noConflict();

window.cachedMobileIC = false;
window.cachedDesktopIC = true;
const renderIconContentSlider = () => {
    if ( false === window.cachedMobileIC && window.matchMedia("(max-width: 767px)").matches ) {
        $('.block-icons-content--bg-image .block-icons-content__blocks').slick({
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        })
        window.cachedMobileIC = true;
        window.cachedDesktopIC = false;
    } else if ( false === window.cachedDesktopIC && window.matchMedia("(min-width: 768px)").matches) {
        $('.block-icons-content--bg-image .block-icons-content__blocks').slick('unslick');
        window.cachedMobileIC = false;
        window.cachedDesktopIC = true;
    }
}

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        renderIconContentSlider()
    },
    loaded() {},
    resized() {
        renderIconContentSlider()
    },
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
